// extracted by mini-css-extract-plugin
export default {"dialog":"dialog--kfFWw","contentInner":"contentInner--K8OAl","description":"description--ef8vn","checkbox":"checkbox--H7rGU","footer":"footer--pdlvL"};